import { Header } from "components/Header"
import { ProductForm } from "components/product-form"
import { ar } from "i18n/ar"

export default function CreateProduct() {
  return (
    <>
      <Header title={ar.addProduct} />
      <ProductForm />
    </>
  )
}
